import React, { useState } from "react";
import "./ChangePassword.css"; // Import custom CSS
import BackgroundVideo from '../BackgroundVideo/BackgroundVideo';

const ChangePassword = () => {
    const [currentPassword, setCurrentPassword] = useState("");
    //const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState("");
    const [errors, setErrors] = useState({ newPassword: "", confirmPassword: "" });
    const [isCurrentPasswordVisible, setIsCurrentPasswordVisible] = useState(false);
    const [isNewPasswordVisible, setIsNewPasswordVisible] = useState(false);
    const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);

    const toggleCurrentPasswordVisibility = () => {
        setIsCurrentPasswordVisible((prev) => !prev);
    };
    
    const toggleNewPasswordVisibility = () => {
        setIsNewPasswordVisible((prev) => !prev);
    };
    
    const toggleConfirmPasswordVisibility = () => {
        setIsConfirmPasswordVisible((prev) => !prev);
    };

    const validatePassword = (password: string) => {
        const minLength = password.length >= 8;
        const hasUpperCase = /[A-Z]/.test(password);
        const hasLowerCase = /[a-z]/.test(password);
        const hasNumber = /\d/.test(password);
        const hasSpecialChar = /[@$!%*?&]/.test(password);

        if (!minLength) return "Password must be at least 8 characters long.";
        if (!hasUpperCase) return "Password must contain at least one uppercase letter.";
        if (!hasLowerCase) return "Password must contain at least one lowercase letter.";
        if (!hasNumber) return "Password must contain at least one number.";
        if (!hasSpecialChar) return "Password must contain at least one special character (@$!%*?&).";
        return "";
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();
    
        // Validate new password
        const newPasswordError = validatePassword(newPassword);
        const confirmPasswordError = newPassword !== confirmPassword ? "Passwords do not match!" : "";
    
        if (newPasswordError || confirmPasswordError) {
            setErrors({ newPassword: newPasswordError, confirmPassword: confirmPasswordError });
            return;
        }    
    };    

    return (
        <React.StrictMode>
            <BackgroundVideo mode={""} />
            <div className="change-container">
                <div className="change-box">
                    <h2>Change Your Password</h2>
                    <form onSubmit={handleSubmit}>
                        <div className="input-group">
                            <label>Current Password</label>
                            <div className="inputWrapper">
                                <input
                                    type={isCurrentPasswordVisible ? 'text' : 'password'}
                                    placeholder="Enter current password"
                                    value={currentPassword}
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                    required
                                />
                                <img
                                    src={isCurrentPasswordVisible ? "/images/eye-open.svg" : "/images/eye-close.svg"}
                                    alt={isCurrentPasswordVisible ? 'Hide password' : 'Show password'}
                                    onClick={toggleCurrentPasswordVisibility}
                                    className="icon"
                                />
                            </div>
                        </div>

                        <div className="input-group">
                            <label>New Password</label>
                            <div className="inputWrapper">
                                <input
                                    type={isNewPasswordVisible ? 'text' : 'password'}
                                    placeholder="Enter new password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    required
                                />
                                <img
                                    src={isNewPasswordVisible ? "/images/eye-open.svg" : "/images/eye-close.svg"}
                                    alt={isNewPasswordVisible ? 'Hide password' : 'Show password'}
                                    onClick={toggleNewPasswordVisibility}
                                    className="icon"
                                />
                            </div>
                            {errors.newPassword && <p className="error-message">{errors.newPassword}</p>}
                        </div>

                        <div className="input-group">
                            <label>Confirm New Password</label>
                            <div className="inputWrapper">
                                <input
                                    type={isConfirmPasswordVisible ? 'text' : 'password'}
                                    placeholder="Confirm new password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                                <img
                                    src={isConfirmPasswordVisible ? "/images/eye-open.svg" : "/images/eye-close.svg"}
                                    alt={isConfirmPasswordVisible ? 'Hide password' : 'Show password'}
                                    onClick={toggleConfirmPasswordVisibility}
                                    className="icon"
                                />
                            </div>
                            {errors.confirmPassword && <p className="error-message">{errors.confirmPassword}</p>}
                        </div>

                        <button type="submit">Change Password</button>
                    </form>

                    {message && <p className="message">{message}</p>}
                </div>
            </div>
        </React.StrictMode>
    );
};

export default ChangePassword;